import { Skeleton } from '@mui/material';
import { useEffect, useRef } from 'react';
import useOnScreen from '../../../../../utils/useOnScreen';

const ConversationSkeleton = ({ length = 10, onSkeletonVisible }: { length?: number; onSkeletonVisible?: () => void }) => {
  const ref = useRef<HTMLDivElement>(null);
  const skeletonVisible = useOnScreen(ref);
  useEffect(() => {
    if (skeletonVisible) onSkeletonVisible?.();
  }, [skeletonVisible]);

  return (
    <div>
      {Array(length)
        .fill(0)
        .map((e, i) => (
          <div ref={i === length - 1 ? ref : null} className="w-full px-4 py-2 flex flex-col space-y-2 overflow-hidden">
            <div className="w-full flex flex-row space-x-1 ">
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" className="w-full" />
            </div>
            <Skeleton variant="text" className="w-full" style={{ marginLeft: 'calc(40px + 0.25rem)' }} />
          </div>
        ))}
    </div>
  );
};
export default ConversationSkeleton;
